import { render, staticRenderFns } from "./StoriesArticleIllustratedMainImgAsset.vue?vue&type=template&id=2f089130&scoped=true&"
import script from "./StoriesArticleIllustratedMainImgAsset.vue?vue&type=script&lang=js&"
export * from "./StoriesArticleIllustratedMainImgAsset.vue?vue&type=script&lang=js&"
import style0 from "./StoriesArticleIllustratedMainImgAsset.vue?vue&type=style&index=0&id=2f089130&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f089130",
  null
  
)

export default component.exports